<template>
    <ErrorAlert />
    <AppContainer class="h-100 w-100">
        <el-card class="text-center login">
            <template #header>
                <h2 class="logo" justify="center">eP2AS License</h2>
            </template>
            <router-view />
        </el-card>
    </AppContainer>
</template>

<script lang="ts">
import ErrorAlert from '@/components/ErrorAlert.vue';
import { defineComponent } from 'vue';
import AppContainer from '@/components/AppContainer.vue';

const Auth = defineComponent({
    components: { AppContainer, ErrorAlert },
    props: {
        prop: {
            type: String,
        },
    },
});
export default Auth;
</script>
